export default __webpack_public_path__ + "static/media/favicon.3771383f.ico";